import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock($setup["Menu"], {
    as: "div",
    class: "relative inline-block text-left"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock($setup["MenuButton"], {
        class: _normalizeClass(["hover:text-primary focus:ring-primary inline-flex items-center justify-center bg-white font-medium text-gray-700 shadow ring-1 ring-gray-300 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-opacity-50", $props.compact ? 'h-9 w-9 rounded-full' : 'rounded px-3 py-2 text-sm'])
      }, {
        default: _withCtx(() => [
          _createVNode($setup["DocumentDownloadIcon"], {
            class: _normalizeClass(["h-5 w-5 text-gray-500", $props.compact ? '' : '-ml-1 mr-2']),
            "aria-hidden": "true"
          }, null, 8 /* PROPS */, ["class"]),
          _createElementVNode("span", {
            class: _normalizeClass($props.compact ? 'sr-only' : '')
          }, _toDisplayString($props.label), 3 /* TEXT, CLASS */),
          (!$props.compact)
            ? (_openBlock(), _createBlock($setup["ChevronDownIcon"], {
                key: 0,
                class: "ml-2 h-4 w-4 text-gray-400",
                "aria-hidden": "true"
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])), [
        [_directive_tippy, $props.compact ? $props.label : undefined]
      ]),
      _createVNode($setup["MenuItems"], { class: "absolute right-0 z-20 mt-2 w-64 origin-top-right overflow-hidden rounded bg-white shadow-xl ring-1 ring-gray-300 focus:outline-none" }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "border-b border-gray-100 bg-gray-50 px-4 py-3" }, [
            _createElementVNode("p", { class: "text-sm font-semibold text-gray-800" }, "Escolha o formato"),
            _createElementVNode("p", { class: "text-xs text-gray-500" }, "Baixe os dados em planilha ou texto.")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode($setup["MenuItem"], null, {
              default: _withCtx(({ active }) => [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["flex w-full items-center rounded px-3 py-2 text-left transition", active ? 'bg-gray-100 text-gray-900' : 'text-gray-700']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectFormat('xlsx')))
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "mr-3 inline-flex h-9 w-12 items-center justify-center rounded bg-emerald-100 text-xs font-bold text-emerald-700" }, " XLSX ", -1 /* CACHED */),
                  _createElementVNode("span", { class: "min-w-0" }, [
                    _createElementVNode("span", { class: "block text-sm font-semibold" }, "Excel (.xlsx)"),
                    _createElementVNode("span", { class: "block text-xs text-gray-500" }, "Planilha nativa para Excel")
                  ], -1 /* CACHED */)
                ]), 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode($setup["MenuItem"], null, {
              default: _withCtx(({ active }) => [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["mt-1 flex w-full items-center rounded px-3 py-2 text-left transition", active ? 'bg-gray-100 text-gray-900' : 'text-gray-700']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectFormat('csv')))
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("span", { class: "mr-3 inline-flex h-9 w-12 items-center justify-center rounded bg-sky-100 text-xs font-bold text-sky-700" }, " CSV ", -1 /* CACHED */),
                  _createElementVNode("span", { class: "min-w-0" }, [
                    _createElementVNode("span", { class: "block text-sm font-semibold" }, "CSV"),
                    _createElementVNode("span", { class: "block text-xs text-gray-500" }, "Arquivo leve separado por colunas")
                  ], -1 /* CACHED */)
                ]), 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */,
        __: [4]
      })
    ]),
    _: 1 /* STABLE */
  }))
}